import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { QuotationRequestModel } from "@model/quotation.model";



@Injectable({
    providedIn: "root",
})
export class MsicApiService {

    constructor(private http: HttpClient) {
    }
    
    GetMsicCode(): Observable<any> {
        return this.http.get<any>("/Msic/GetMsicCode");
    }
}
